export default __webpack_public_path__ + "media/images/celeste_dark_standing-68d56c10b8aaba733007e214ede513c0.png";